var map = {
	"./argentina.svg": "e146",
	"./australiaNewZeland.svg": "2701",
	"./brazil.svg": "2de0",
	"./chile.svg": "049b",
	"./colombia.svg": "3867",
	"./france.svg": "0384",
	"./germany.svg": "bce1",
	"./ireland.svg": "cfa3",
	"./italy.svg": "8b25",
	"./peru.svg": "44b7",
	"./romania.svg": "14e2",
	"./spain.svg": "e46d",
	"./uk.svg": "c885",
	"./unitedStates.svg": "788c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3667";